import Vue from 'vue'

export default Vue.extend({
  template: `
    <div>
      <span v-if="!statuses.includes(params.data.archiveStatus)">
        <div v-if="params.type === 'Project Dashboard'" class="archive-div">
          <a-tooltip placement="top" title="View" v-if="params.data.isArchive || params.data.archiveStatus === 'QUEUED'">
            <a @click="() => editProject()">
              <i class="fa fa-eye actionIcon" aria-hidden='true' style="color: #007bff;"/>
            </a>
          </a-tooltip>
          <a-tooltip placement="top" title="Edit" v-if="!params.data.isArchive && params.data.archiveStatus !== 'QUEUED'">
            <a @click="() => editProject()" class="mr-1">
              <i class="fa fa-pencil actionIcon" aria-hidden='true' style="color: #007bff;"/>
            </a>
          </a-tooltip>
          <a-tooltip placement="top" title="Archive Project" v-if="!params.data.isArchive && params.data.archiveStatus !== 'QUEUED'">
            <a @click="() => archiveProject()" class="mr-1">
              <a-avatar size="small" :src="archiveImage" />
            </a>
          </a-tooltip>
          <a-tooltip placement="top" title="Unarchive Project" v-if="params.data.isArchive && params.data.archiveStatus !== 'QUEUED'">
            <a @click="() => archiveProject()" class="mr-1">
              <a-avatar size="small" :src="unarchiveImage" />
            </a>
          </a-tooltip>
          <a-tooltip placement="top" title="Clone" v-if="params.data.archiveStatus !== 'QUEUED'">
            <a @click='() => cloneProject()' class="mr-1">
              <i class='fa fa-clone actionIcon' aria-hidden='true' style='color: #71283e'/>
            </a>
          </a-tooltip>
          <a-tooltip placement="top" title="Delete" v-if="!params.data.isArchive && params.data.archiveStatus !== 'QUEUED'">
            <a @click="() => deleteProject()">
              <i class="fa fa-trash-o deleteIcon" aria-hidden='true' style='color: #e03848'/>
            </a>
          </a-tooltip>
          <a-tooltip placement="top" :title="!params.data.isArchive ? 'Abort Archiving' : 'Abort Unarchiving'" v-if="params.data.archiveStatus === 'QUEUED'">
            <a @click="() => abortProject()">
              <i class="fa fa-ban actionIcon" aria-hidden='true' style="color: #e03848;"/>
            </a>
          </a-tooltip>
        </div>
        <a-tooltip placement="top" title="Restore" v-if="params.type === 'Restore Project'">
          <a @click="() => restoreProject()" :disabled="this.params.data.isLinked">
            <i
              class="fa fa-arrow-circle-o-up actionIcon"
              style="color: #e03848"
            />
          </a>
        </a-tooltip>
      </span>
      <span v-else>
        <a-tooltip placement="top" title="Archiving In Progress" v-if="params.data.archiveStatus === 'ARCHIVING_IN_PROGRESS'">
          <i class="fa fa-info-circle actionIcon" style="color: #007bff" />
        </a-tooltip>
        <a-tooltip placement="top" title="Unarchiving In Progress" v-if="params.data.archiveStatus === 'UNARCHIVING_IN_PROGRESS'">
          <i class="fa fa-info-circle actionIcon" style="color: #007bff" />
        </a-tooltip>
      </span>
    </div>
    `,
  data: function() {
    return {
      value: '',
      archiveImage: process.env.BASE_URL + 'resources/images/archive.png',
      unarchiveImage: process.env.BASE_URL + 'resources/images/unarchive.png',
      statuses: ['ARCHIVING_IN_PROGRESS', 'UNARCHIVING_IN_PROGRESS'],
    }
  },
  beforeMount() {
    this.value = this.params.value
  },
  methods: {
    editProject() {
      sessionStorage.setItem('Is-Archive', this.params.data.isArchive)
      this.$router.push(`dashboard/project/${this.params.data.id}`)
    },
    restoreProject() {
      this.$root.$emit('restoreProject', this.params.data)
    },
    deleteProject() {
      this.$root.$emit('deleteProject', this.params.data)
    },
    cloneProject() {
      this.$root.$emit('cloneProject', this.params.data)
    },
    archiveProject() {
      this.$root.$emit('archiveProject', this.params.data)
    },
    abortProject() {
      this.$root.$emit('abortProject', this.params.data)
    },
  },
})
